import { memo } from "react";

import { OrderStatusDTO } from "@/common/api";
import {
  Button,
  Card,
  CardContent,
  Input,
  Select,
  SelectContent,
  SelectItem,
} from "@/common/components";
import type { TradingFiltersSchema } from "@/pages/trading/model";

interface TradingFiltersProps {
  statuses: OrderStatusDTO[] | null;
  statusId: string;
  onStatusIdChange: (id: string) => void;
  isStatusesLoading: boolean;
  createdAt: TradingFiltersSchema["createdAt"];
  onCreatedAtChange: (date: string) => void;
  createdAtError?: string | null;
  orderNumber: string;
  onOrderNumberChange: (number: string) => void;
  onReset: () => void;
}

export const TradingFilters = memo(function TradingFilters({
  statuses,
  statusId,
  onStatusIdChange,
  isStatusesLoading,
  createdAt,
  onCreatedAtChange,
  createdAtError,
  orderNumber,
  onOrderNumberChange,
  onReset,
}: TradingFiltersProps) {
  return (
    <Card className="mb-6">
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Статус
            </label>
            <Select
              value={statusId}
              onValueChange={onStatusIdChange}
              disabled={isStatusesLoading}
              placeholder="Выберите статус"
            >
              <SelectContent>
                <SelectItem value="">Все статусы</SelectItem>
                {statuses?.map((status) => (
                  <SelectItem key={status.code} value={String(status.id)}>
                    {status.description}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Дата создания
            </label>
            <Input
              key="createdAt"
              type="date"
              name="createdAt"
              value={createdAt}
              onChange={(e) => onCreatedAtChange(e.target.value)}
              placeholder="ДД.ММ.ГГГГ"
              className={`block ${createdAtError ? "border-red-500" : ""}`}
            />
            {createdAtError && <p className="text-xs text-red-500 mt-1">{createdAtError}</p>}
          </div>
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Номер заявки
            </label>
            <Input
              placeholder="Введите № заявки"
              value={orderNumber}
              onChange={(e) => onOrderNumberChange(e.target.value)}
            />
          </div>
          <div className="flex items-start mt-5">
            <Button
              variant="outline"
              className="w-full"
              onClick={(e) => {
                e.stopPropagation();
                onReset();
              }}
            >
              Сбросить
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
